export const findAnswerByHasExternalList = (answers, hasExternalList) => {
  return answers.find(answer => answer?.hasExternalList === hasExternalList)
}
